import { Link } from "react-router-dom";
import { ArrowRight, Camera } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { ARTISTS } from "../data/artists";
import { MOOD_IMAGES } from "../data/gallery";

const ArtistCard = ({ artist, index }) => (
  <Reveal delay={(index % 2) * 0.1}>
    <article data-testid={`artist-card-${artist.slug}`} className="card-dark group grid h-full overflow-hidden md:grid-cols-[240px_1fr]">
      <div className="relative flex min-h-[220px] items-center justify-center overflow-hidden bg-[#0f0f0f]">
        {artist.photo ? (
          <img
            src={artist.photo}
            alt={`${artist.name} portré`}
            data-testid={`artist-photo-${artist.slug}`}
            className={`absolute inset-0 h-full w-full object-cover ${artist.photoPos || "object-top"} transition-transform duration-700 group-hover:scale-105`}
          />
        ) : (
          <>
            <img
              src={MOOD_IMAGES.mist}
              alt=""
              className="absolute inset-0 h-full w-full object-cover opacity-15 transition-transform duration-700 group-hover:scale-110"
            />
            <div className="relative flex flex-col items-center gap-3">
              <span className="font-display text-6xl font-medium tracking-[0.15em] text-white/85 transition-colors duration-500 group-hover:text-[#C04B58]">
                {artist.name.split(" ").map((w) => w[0]).join("")}
              </span>
              <span className="flex items-center gap-1.5 font-mono2 text-[9px] uppercase tracking-[0.3em] text-zinc-600">
                <Camera size={11} /> Fotó hamarosan
              </span>
            </div>
          </>
        )}
        <span className="absolute bottom-0 left-0 h-px w-full origin-left scale-x-0 bg-[#9A3542] transition-transform duration-500 group-hover:scale-x-100" />
      </div>

      <div className="flex flex-col p-7 sm:p-8">
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
          <h3 className="font-display text-2xl font-semibold text-white">{artist.name}</h3>
          {artist.alias && <span className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-[#C04B58]">{artist.alias}</span>}
        </div>
        <p className="mt-1 text-xs uppercase tracking-[0.2em] text-zinc-500">{artist.role}</p>

        <div className="mt-4 flex flex-wrap gap-2">
          {artist.tags.map((t) => (
            <span key={t} className="rounded-full border border-white/10 px-3 py-1 text-[11px] text-zinc-400">
              {t}
            </span>
          ))}
        </div>

        <p className="mt-5 flex-1 text-sm leading-relaxed text-zinc-400">{artist.bio}</p>

        <div className="mt-7">
          <Link
            to={`/galeria?artist=${artist.slug}`}
            data-testid={`artist-gallery-btn-${artist.slug}`}
            className="btn-ghost !px-5 !py-2.5 !text-xs"
          >
            Saját galéria <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </article>
  </Reveal>
);

export default function Artists() {
  return (
    <div data-testid="artists-page">
      <PageHeader
        testId="artists-header"
        motif="flower"
        eyebrow="Tetoválóink & művészek"
        title={<>Nyolc művész, <span className="italic text-[#C04B58]">egy ház.</span></>}
        description="Ismerd meg a stúdió művészeit — a realisztikus portréktól a fineline vonalakon át a henna és jagua testdíszítésig. Időpontfoglalás előtt minden művésszel személyesen egyeztetünk."
      />
      <section className="mx-auto max-w-7xl space-y-6 px-5 pb-28 sm:px-8">
        {ARTISTS.map((a, i) => (
          <ArtistCard key={a.slug} artist={a} index={i} />
        ))}
      </section>
    </div>
  );
}
